import { getRefId, ensureNumber, getMissionStatus } from "../utils/utils"
import { isAfter } from "date-fns/isAfter"
import { isBefore } from "date-fns/isBefore"
import isSameWeek from "date-fns/isSameWeek"
import { isSameDay } from "date-fns/isSameDay"
import { differenceInDays } from "date-fns/differenceInDays"
import { isWithinInterval } from "date-fns/isWithinInterval"
import { findAiEndDate } from "../utils/dates"
import { toZonedTime } from "date-fns-tz"
import flatMap from "lodash/flatMap"
import uniqBy from "lodash/uniqBy"
import { startOfWeek, endOfWeek } from "date-fns"

export function recommender(app, date) {
    const personId = app.state.person._id
    const currentDate = new Date()

    const myMissions = app.state.missions.filter((m) => {
        if (isBefore(new Date(m.createdAt), new Date("2025-01-08"))) {
        } else if (!m.kickedOff || m.isTemplate || m.isModel) {
            return false
        }

        const status = getMissionStatus(m)

        let isWithin
        try {
            isWithin = isWithinInterval(date, {
                start: startOfWeek(toZonedTime(m.planStartDate), { weekStartsOn: 1 }),
                end: endOfWeek(toZonedTime(m.planEndDate), { weekStartsOn: 1 }),
            })
        } catch (e) {
            app.silentFail(`weo3r43i8883-2-mission${m?._id}`)
            return false
        }

        if (status !== "active" || m.isModel || m.isTemplate || !isWithin) {
            return false
        }

        const person = m.people?.find((p) => getRefId(p) === personId)
        return person && person.permission < 3
    })

    const missionMap = new Map(myMissions.map((m) => [m._id, m]))

    const flatPlanItems = flatMap(myMissions, "planItems")
    const flatPlanRoles = flatPlanItems.filter(
        (p) => p.type === "person" && p.person === personId && p.raciOnTasks?.length
    )

    const flatActions = flatMap(
        flatPlanItems.filter((p) => p.type === "phase"),
        "actions"
    )

    const allActionItems = flatMap(flatActions, "actionItems")

    const myActionItems = new Set()
    allActionItems.forEach((ai) => {
        if (ai && ai.people?.includes(personId) && ai.status !== "done") {
            const mission = missionMap.get(ai.missionId)

            if (mission.projectType === "mx-gantt") {
                let myRaciOnTask = null

                for (const pi of flatPlanRoles) {
                    if (pi.person === app.state.person._id) {
                        const match = pi.raciOnTasks.find((rt) => rt.taskId === ai._id)
                        if (match) {
                            myRaciOnTask = match
                            break
                        }
                    }
                }

                if (!myRaciOnTask) {
                    myActionItems.add(ai)
                } else if (myRaciOnTask.raciArray.some((item) => item === "r" || item === "a")) {
                    myActionItems.add(ai)
                }
            } else {
                if (mission && ai.week) {
                    myActionItems.add(ai)
                }
            }
        }
    })

    flatPlanRoles.forEach((pi) => {
        if (missionMap.get(pi.missionId)?.projectType === "mx-gantt") {
            pi.raciOnTasks.forEach((pr) => {
                const foundAi = allActionItems.find((a) => a._id === pr.taskId)
                if (foundAi && foundAi?.status !== "done") {
                    if (pr.raciArray?.includes("r") || pr.raciArray?.includes("a")) {
                        myActionItems.add(foundAi)
                    }
                }
            })
        }
    })

    const weightedActionItems = uniqBy(Array.from(myActionItems), "_id").map((ai) => {
        const mission = missionMap.get(ai.missionId)
        const endDate = findAiEndDate(ai, mission)
        const isThisWeek = isSameWeek(ai.endDate ? toZonedTime(ai.endDate) : toZonedTime(ai.week), new Date(), {
            weekStartsOn: 1,
        })
        const isEndingToday = isSameDay(endDate, new Date())
        const isDueToday = ai.endDate ? isSameDay(toZonedTime(ai.endDate), new Date()) : false

        const overDueAmount = !endDate ? 0 : isAfter(currentDate, endDate) ? differenceInDays(currentDate, date) : 0

        if (overDueAmount > 20) {
            return { ...ai, weight: 0 }
        }

        let weight = isDueToday ? 14 : isEndingToday ? 10 : isThisWeek ? 5 : 1

        if (mission.client) {
            weight += 2
        }

        const closeToEndDate = overDueAmount || isBefore(endDate, date) ? 0 : differenceInDays(endDate, date) * 0.1

        weight -= ensureNumber(closeToEndDate) * 0.3
        weight += ensureNumber(ai.prevEndDate?.length) * 0.1
        weight += ensureNumber(ai.complexityMultiplier || 10) * 0.3
        weight += ensureNumber(ai.people?.length) * 0.03
        weight += overDueAmount * 10

        if (ai.metaType === 0) {
            weight += weight * 1.5
        }

        return { ...ai, weight }
    })

    return weightedActionItems.sort((a, b) => b.weight - a.weight)
}
